import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Container from './components/Container';
import AllGames from './pages/AllGames';
import PlayableGames from './pages/PlayableGames';
import GameDetail from './pages/GameDetail';
import PlayPage from './pages/PlayPage';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import SetPassword from './pages/SetPassword';
import KepithorGames from './pages/KepithorGames';
import { useEffect } from "react";
import { loadAllGames } from "./data/allGames";
import GBRRules from './pages/GBRRules';
import MediaCoverage from "./pages/MediaCoverage";

const Protected = ({ children }) => {
const { user } = useAuth();
if (!user) return <Navigate to="/login" replace />;
return children;
};


export default function App(){

 useEffect(() => {
  loadAllGames();  
  const interval = setInterval(() => loadAllGames(), 10 * 60 * 1000);
  return () => clearInterval(interval);
}, []);


return (
    
    // <div className="min-h-screen bg-slate-950 text-slate-100">
    //   <div className="max-w-6xl mx-auto px-4 py-6">
<AuthProvider>
<Container>

      <Routes>


        {/* Home = full directory */}
        <Route path="/" element={<AllGames />} />

        {/* Kepithor-only list (existing Games.js) */}
        <Route path="/kepithor" element={<KepithorGames />} />

        {/* All playable on-site */}
        <Route path="/playable" element={<PlayableGames />} />

        {/* Game detail page */}
        <Route path="/game/:id" element={<GameDetail />} />

        {/* Existing play page for webglPath */}
        <Route path="/play/:id" element={<PlayPage />} />

        <Route path="/media" element={<MediaCoverage />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/set-password" element={<SetPassword />} />
        
          {/* Eula/terms/privacy routes will still render the same pages,
              the Footer decides to show the modal based on the URL */}
          <Route path="/eula" element={<AllGames />} />
          <Route path="/terms" element={<AllGames />} />
          <Route path="/privacy" element={<AllGames />} />
          <Route path="/list_your_game" element={<AllGames />} />

          


          
          <Route path="/gbr-rules" element={<GBRRules />} />
          <Route path="/rules" element={<GBRRules />} />




      </Routes>

</Container>
</AuthProvider>
    //   </div>
    // </div>
);
}